import { Stacker } from "@/components/molecules/Stacker";
import { ServiceItem } from "@/components/organisms/ServiceItem";
import { AiRedesignLab } from "@/components/organisms/AiRedesignLab";
import { AiDrivenSupport } from "@/components/organisms/AiDrivenSupport";
import { AiSecurityAdvisory } from "@/components/organisms/AiSecurityAdvisory";
import { TwpBanner } from "@/components/organisms/TwpBanner";

const services = [
  {
    href: "contracted_development",
    src: "/service-contractedDevelopment.webp",
    lead: "お客様のご要件にあわせ、最適な設計を施したシステムを構築いたします。",
    title: "受託開発",
    title_eng: "Contracted Development",
    body: 'トッカシステムズでは、お客様のやり取りから開発・保守/運用まで、全ての工程を自社で行っております。<br class="tbpc"/>最新のAI開発支援ツールを活用しながら、お客様とのやり取りから課題を見つけだし、システム構築の技術・ノウハウを融合させて問題を解決いたします。',
    solutions: [
      "開発リソースの不足や技術的な課題",
      "既存システムの老朽化や保守性の問題",
      "新技術導入時の技術選定や設計の悩み",
      "プロジェクト管理や品質管理の課題",
      "短期間での開発やコスト最適化の要求"
    ],
    tags: [
      {
        label: "要件定義",
      },
      {
        label: "システム設計",
      },
      {
        label: "プログラム開発",
      },
      {
        label: "フロントエンド",
      },
      {
        label: "バックエンド",
      },
      {
        label: "会員基盤",
      },
      {
        label: "認証基盤",
      },
      {
        label: "決済アプリ",
      },
      {
        label: "WEBサービス",
      },
      {
        label: "オンラインサロン",
      },
      {
        label: "業務システム",
      },
      {
        label: "業務効率化",
      },
      {
        label: "AI",
      },
      {
        label: "Devin",
      },
      {
        label: "GitHub Copilot",
      },
      {
        label: "Claude",
      },
      {
        label: "AI開発支援",
      },
      {
        label: "コード生成AI",
      },
      {
        label: "デジタルマーケティング",
      },
      {
        label: "MA",
      },
      {
        label: "SNS連携",
      },
      {
        label: "シングルサインオン",
      },
      {
        label: "CMS",
      },
      {
        label: "EC",
      },
      {
        label: "iOSアプリ",
      },
      {
        label: "Androidアプリ",
      },
      {
        label: "Java",
      },
      {
        label: "PHP",
      },
      {
        label: "JavaScript",
      },
      {
        label: "React",
      },
      {
        label: "Next",
      },
      {
        label: "Python",
      },
      {
        label: "C#",
      },
      {
        label: "Swift",
      },
      {
        label: "HTML5",
      },
      {
        label: "CSS",
      },
      {
        label: "AWS",
      },
      {
        label: "Azure",
      },
      {
        label: "GCP",
      },
      {
        label: "Docker",
      },
      {
        label: "CI/CD",
      },
      {
        label: "テスト自動化",
      },
      {
        label: "Jamstack",
      },
      {
        label: "ヘッドレスCMS",
      },
    ],
  },
  {
    href: "solution",
    src: "/service-solution.webp",
    title: "ソリューション",
    title_eng: "Solution",
    lead: "業務に特化し、技術を結集させた最適解を提供します。",
    body: 'WEBサービスやアプリの構築、業務効率化、メールの構築、クラウドサービスを用いたインフラ構築など、<br class="tbpc"/>お客様の課題や業務に特化した具体的な問題解決の支援をいたします。',
    solutions: [
      "業務効率化や生産性向上の課題",
      "既存業務プロセスのデジタル化の遅れ",
      "データ活用や分析基盤の不足",
      "システム間連携や情報共有の問題",
      "コスト削減と品質向上の両立"
    ],
    tags: [
      {
        label: "デジタルマーケティング",
      },
      {
        label: "コンテンツ配信",
      },
      {
        label: "プラットフォームソリューション",
      },
      {
        label: "オンラインサロン",
      },
      {
        label: "ECサイト",
      },
      {
        label: "電子マネー決済",
      },
      {
        label: "ペーパーレス",
      },
      {
        label: "DX",
      },
      {
        label: "AWS",
      },
      {
        label: "Azure",
      },
      {
        label: "メールシステム",
      },
      {
        label: "多言語対応",
      },
      {
        label: "アクセス解析",
      },
      {
        label: "セキュリティ",
      },
      {
        label: "脆弱性診断",
      },
      {
        label: "性能向上",
      },
      {
        label: "運用支援",
      },
      {
        label: "エンジニアリングサービス",
      },
	  {
        label: "クラウドEC",
      },
    ],
  },
  {
    href: "web_development",
    src: "/service-webDevelopment.webp",
    title: "WEB構築",
    title_eng: "WEB Development",
    lead: "フロントエンドからCMSの構築・運用まで、持続的な成長運用を支援します",
    body: '非常に速いサイクルで技術のトレンドが移り変わる中、最新のトレンドへの対応・Googleの検索エンジンへの最適化をすすめ、<br class="tbpc"/>システム開発の技術をタイムリーに融合させることで、UIとUXの側面から優れたWebデザインをご提供いたします。',
    solutions: [
      "ウェブサイトの集客力や検索順位の向上",
      "モバイル対応やレスポンシブデザインの課題",
      "サイト表示速度やパフォーマンスの問題",
      "ユーザビリティやアクセシビリティの改善",
      "ブランディングやデザイン統一の必要性"
    ],
    tags: [
      {
        label: "UI/UX",
      },
      {
        label: "HTML5",
      },
      {
        label: "CSS",
      },
      {
        label: "SEO",
      },
      {
        label: "アクセス解析",
      },
      {
        label: "CI・VI・ブランディング",
      },
      {
        label: "UIデザイン",
      },
      {
        label: "ウェブデザイン",
      },
      {
        label: "ウェブコンサルティング",
      },
      {
        label: "HTMLコーディング",
      },
      {
        label: "GoogleAnalytics",
      },
      {
        label: "Adobe",
      },
      {
        label: "CMS",
      },
      {
        label: "ヘッドレスCMS",
      },
      {
        label: "SpeedCMS",
      },
      {
        label: "HeartCore",
      },
      {
        label: "microCMS",
      },
    ],
  },
  {
    href: "consulting",
    src: "/service-consulting.webp",
    lead: "お客さまの課題解決に向けて、最適なカタチをご提案します",
    title: "コンサルティング",
    title_eng: "Consulting",
    body: 'IT経営戦略の立案を支援、情報化の企画、開発、運用までをサポートしています。<br class="tbpc"/>真の経営課題を顕在化させ、また、様々な課題をシステム化して実現していくための道筋を、豊富な経験・技術に基づきご提案いたします。',
    solutions: [
      "IT戦略や情報化計画の策定",
      "業務プロセスの見直しや最適化",
      "システム導入時の要件定義や選定支援",
      "プロジェクト管理や推進体制の構築",
      "ROI向上やコスト最適化の実現"
    ],
    tags: [
      {
        label: "経営戦略",
      },
      {
        label: "業務効率化",
      },
      {
        label: "サービス企画支援",
      },
      {
        label: "システム方針策定支援",
      },
      {
        label: "市場調査",
      },
      {
        label: "製品選定支援",
      },
      {
        label: "プロジェクト推進支援",
      },
    ],
  },
  {
    href: "package",
    src: "/service-package.webp",
    lead: "技術とノウハウを結集した製品・サービスを提供します",
    title: "パッケージ",
    title_eng: "Package",
    body: "様々なシステムやサービスを構築する中で得た技術やノウハウに基づき開発した製品・サービスをご提供します。<br />また、パートナープロダクトに自社の技術とノウハウを掛け合わせ、<br />付加価値の高いパッケージ・サービスのインテグレーションサービスを提供いたします。",
    solutions: [
      "自社開発コストや開発期間の課題",
      "技術的な専門知識や経験の不足",
      "スケーラビリティや拡張性の要求",
      "セキュリティや運用保守の負担",
      "市場投入スピードの向上"
    ],
    tags: [
      {
        label: "CMS",
      },
      {
        label: "ヘッドレスCMS",
      },
      {
        label: "メール",
      },
      {
        label: "セキュリティ",
      },
      {
        label: "オンラインサロン",
      },
      {
        label: "歯科医院CMS",
      },
      {
        label: "商店街CMS",
      },
      {
        label: "保育園CMS",
      },
    ],
  },
];

export const ServiceList = () => {
  return (
    <>
      <Stacker className="mx-auto mt-6 grid max-w-7xl grid-cols-1 md:mt-8 lg:mt-10">
        <AiDrivenSupport />
        <AiSecurityAdvisory />
        <TwpBanner className="col-span-1 mb-6 md:mb-8" />
        <AiRedesignLab />
        {services.map((service) => (
          <div key={service.index}>
            <ServiceItem
              href={service.href}
              src={service.src}
              lead={service.lead}
              title={service.title}
              body={service.body}
              tags={service.tags}
              solutions={service.solutions}
            />
          </div>
        ))}
      </Stacker>
    </>
  );
};
